import PocketBase from 'pocketbase'

const client = new PocketBase(process.env.VUE_APP_POCKETBASE_URL)

export default client
